import { SeasonContext, SeasonListItem, SeasonName, SeasonTypeCode } from '../types/Season';

const seasonTypeToName: Record<SeasonTypeCode, SeasonName> = {
  SPR: 'SPRING',
  SUM: 'SUMMER',
  FAL: 'FALL',
  WNT: 'WINTER',
  SAF: 'SAFRINHA',
};

export const getSeasonNameFromType = (type: SeasonTypeCode): SeasonName =>
  seasonTypeToName[type];

export const getSeasonTypeCodeFromTag = (seasonTag: string): SeasonTypeCode =>
  seasonTag.split(':').filter(Boolean).pop() as SeasonTypeCode;

export const resolveSeasonYear = (season: SeasonListItem | undefined, seasonTag: string): number => {
  if (season?.year) {
    return season.year;
  }

  return Number.parseInt(seasonTag.split(':')[0], 10);
};

export const buildSeasonContext = (
  seasonTag: string,
  season: SeasonListItem | undefined,
): SeasonContext => ({
  seasonTag,
  seasonName: getSeasonNameFromType(getSeasonTypeCodeFromTag(seasonTag)),
  year: resolveSeasonYear(season, seasonTag),
});

export const createSeasonContexts = (
  seasons: Record<string, SeasonListItem>,
  activeSeasons: Array<{ id?: string | null }>,
): SeasonContext[] => {
  const tags = new Set<string>(Object.keys(seasons));
  activeSeasons.forEach(({ id }) => {
    if (id) {
      tags.add(id);
    }
  });

  const contexts: SeasonContext[] = [];
  tags.forEach((seasonTag) => {
    const context = buildSeasonContext(seasonTag, seasons[seasonTag]);
    contexts.push(context);
  });

  return contexts;
};

export const mergeSeasonContexts = (
  primary: SeasonContext[],
  tags: string[],
  seasons: Record<string, SeasonListItem>,
): SeasonContext[] => {
  const merged = new Map<string, SeasonContext>();
  primary.forEach((context) => {
    merged.set(context.seasonTag, context);
  });

  new Set(tags).forEach((seasonTag) => {
    const context = buildSeasonContext(seasonTag, seasons[seasonTag]);
    merged.set(seasonTag, context);
  });

  return Array.from(merged.values());
};
